export { ScatterChart, type ScatterChartProps } from './ScatterChart';
